import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { langType, withLang } from '../../../i18n';
import {
  navigateTo
} from '../../../util';

const SchedulingIconButton = ({
  route, surveyId, translate: t, disabled
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="actionButton icon--time"
      title={t('survey.scheduling')}
      onClick={() => navigateTo(navigate, route, surveyId)}
      disabled={disabled}
      data-cy="scheduling-icon-button"
    />
  );
};
const {
  string
} = PropTypes;

SchedulingIconButton.propTypes = {
  surveyId: string.isRequired,
  ...langType
};

export default withLang(SchedulingIconButton);
